import { Identifier, QueryParams } from '@heda/core-util';

export class ClinicalDocumentPerson {
  public id: string;
  public identifier: Identifier;
  public givenName: string;
  public familyName: string;
}

export class ClinicalDocumentOrganization {
  public identifier: Identifier;
  public name: string;
}

export class ClinicalDocument {
  public identifier: Identifier;
  public version: string;
  public type: string;
  public author: ClinicalDocumentPerson;
  public organization: ClinicalDocumentOrganization;
  public patient: ClinicalDocumentPerson;
}

export class ClinicalDocumentSearchParams extends QueryParams {
  public patient: string;
  public type: string;
  public from?: Date;
  public to?: Date;
  public identifier: Identifier | string;
  public patientIdentifier?: string;
  public patientCountry?: string;
  public clinicalDocumentId?: string;
}

export class ClinicalDocumentMeta {
  public documentKey: string;
  public hasAttachments: boolean;
}

export class ClinicalDocumentAttachment {
  public id: string;
  public fileName: string;
  public contentType: string;
  public content: string;
}
